export const environment = {
  production: true,             
  OuthToken : '0^tHt0{3N',
  AdminToken : 'Adm1nAu7h',
  // API Keys - Move to secure environment variables in production
  geocodingApiKey: '967e6525654641dda7f8da76197220f9',
  googleMapsApiKey: 'AIzaSyBkjAfVEj_6dB6tzgfVgnPUNP5AnYHtQW8'
};
